window.addEventListener("load", function () {

  initCollectionSizes()

  // let currentPage = location.href;

  // const checkPageLocation = function() {
  // collectionSizesPageChange()
  // }

  // let collectionWrapper = document.querySelector('.products.boost-pfs-filter-products')

  // let observer = new MutationObserver(checkPageLocation);

  // observer.observe(collectionWrapper, {
  // childList: true // observe direct children
  // });

});

function initCollectionSizes() {
  document.querySelectorAll('.sizes-wrapper').forEach((el) => {
    collectionSizesSetGrid(el)
  })

  document.querySelectorAll('.sizes-list-item').forEach((el) => {
    collectionSizesSetEvent(el)
  })
  setTimeout(() => {
    if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
      window._swat.initializeActionButtons('#product-grid')
    }
  }, 100);

  const openButtons = document.querySelectorAll('.add-to-bag-modal-open');
  const closeButtons = document.querySelectorAll('.add-to-bag-modal-close');

  openButtons.forEach(openButton => {
    openButton.addEventListener('click', event => {
      const modal = event.target.nextElementSibling;
      modal.classList.add('modal-open');
      const dropdown = event.target.closest('.product__info').querySelector('.dropdownbox-selected-variant');
      dropdown.textContent = 'Please Select';
      const notifyMe = modal.querySelector('.notify-me-a');
      notifyMe.style.display = 'none';
      const addButton = modal.querySelector('.collection_add');
      addButton.value = 'Add To Bag';
      addButton.style.display = 'block';
    });
  });
  closeButtons.forEach(closeButton => {
    closeButton.addEventListener('click', event => {
      const modal = event.target.closest('.add-to-bag-modal');
      modal.classList.remove('modal-open');
      const dropdowns = document.querySelectorAll('.main-list-variants');
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('showMenu');
      });
    });
  });
}

// function collectionSizesPageChange() {
// console.log('test')
// let url = `${window.location.href}`;
// let dataPage = 1;
// if(url.indexOf("page=") > -1 ) {
// let currentPage = url.split("page=")[1].split("&")[0]
// let pageNumber = parseInt(currentPage)
//     dataPage = pageNumber;
// }
// setTimeout(() => {
// let collectionSizesWrapper = document.querySelectorAll(`div[data-page="${Number(dataPage)}"] .sizes-wrapper`)
// collectionSizesWrapper.forEach(el => {
//     if (el.getAttribute('grid-size-set') !== 'true') {
//     collectionSizesSetGrid(el)
//     }
// })

// let collectionPageItemSizeEls = document.querySelectorAll(`div[data-page="${Number(dataPage)}"] .sizes-list-item`)
// collectionPageItemSizeEls.forEach(el => {

//     if (el.getAttribute('listener') !== 'true') {
//     collectionSizesSetEvent(el)
//     }
// });
// }, 900);
// }

function collectionSizesSetGrid(el) {
  if (el.childElementCount > 8) {
    el.classList.add('collection-sizes-grid-5')
  } else if (el.childElementCount > 4) {
    el.classList.add('collection-sizes-grid-4')
  } else {
    el.classList.add('collection-sizes-grid-2')
  }
  el.setAttribute('grid-size-set', 'true')
}

function collectionSizesSetEvent(el) {
  // When a size is clicked toggle the active class and update the variant id that gets submittes when being added to cart
  el.addEventListener("click", function (event) {
    // add active class to target
    event.target.classList.toggle("active-size-item")
    // Loop through and remove class from targets siblings
    let sibling = event.target.parentNode.firstChild;
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== event.target) {
        sibling.classList.remove('active-size-item')
      }
      sibling = sibling.nextSibling;
    }
    // Update the product form input with the variant id of the selected size
    let listWrapper = event.target.parentNode
    let formVariantInput = listWrapper.parentNode.querySelector('form input[name="id"]')
    let formSubmitButton = listWrapper.parentNode.querySelector('.collection-page-add-to-cart')
    let notifyMeButton = listWrapper.parentNode.querySelector('.collection-notify-btn')
    formSubmitButton.classList.remove('notify')
    formSubmitButton.disabled = false
    formVariantInput.setAttribute('value', event.target.getAttribute('data-variant-id'))
    if (event.target.getAttribute('data-variant-available') === "false") {
      formSubmitButton.classList.add('hidden')
      notifyMeButton.classList.remove('hidden')
      notifyMeButton.setAttribute('href', event.target.getAttribute('data-variant-url'))
    } else {
      formSubmitButton.setAttribute('value', 'Add To Bag')
      formSubmitButton.classList.remove('hidden')
      notifyMeButton.classList.add('hidden')
    }
  });
  el.setAttribute('listener', 'true');
}

/* Collection product swatches behaviour
   - clicking a swatch updates the product card image
   - selected swatch receives a border
   - clicking the product image will navigate to the PDP with the selected variant
   - swatch click updates both product image link and product title link to new product URL
*/
function initCollectionGridEvents() {
  if (typeof jQuery === 'undefined') {
    setTimeout(initCollectionGridEvents, 50);
    return;
  }
  var $ = jQuery;
  $(document).on('click', '.product-swatches .swatch-btn', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $card = $btn.closest('.product');
    var productUrl = $btn.data('product-url');
    var imageUrl = $btn.data('product-image') || '';
    var hoverImageUrl = $btn.data('hover-image') || '';
    var productPrice = $btn.data('product-price');
    var productComparePrice = $btn.data('product-compare-price');
    var inlineStyle = $btn.attr('style') || '';
    var $swatchLi = $btn.closest('.swatch');

    // mark selection
    $card.find('.swatch-btn').removeClass('active');
    $btn.addClass('active');

    // update product image background or style
    if (imageUrl) {
      $card.find('.product__image').css('background-image', 'url(' + imageUrl + ')');
      $card.find('.product__image-hover').css('background-image', 'url(' + hoverImageUrl + ')');
    } else if (inlineStyle) {
      $card.find('.product__image').attr('style', inlineStyle);
      $card.find('.product__image-hover').attr('style', inlineStyle);
    }

    // update product image link to new product URL with variant query param
    var $imageLink = $card.find('.product-image-link');
    if ($imageLink.length && productUrl) {
      $imageLink.attr('href', productUrl);
    }

    // update product title link to new product URL
    var $titleLink = $card.find('.product__title-link');
    if ($titleLink.length && productUrl) {
      $titleLink.attr('href', productUrl);
    }

    /* update product price to new product price */
    var $cardPrice = $card.find('[data-price] span');
    if ($cardPrice.length && productPrice) {
      $cardPrice.text(productPrice);
    }
    var $priceWrapper = $card.find('[data-price]');
    var $cardComparePrice = $priceWrapper.find('strike');

    var $priceWrapper = $card.find('[data-price]');
    var $cardComparePrice = $priceWrapper.find('strike');

    if (productComparePrice) {
      if ($cardComparePrice.length) {
        $cardComparePrice.text(productComparePrice);
      } else {
        $priceWrapper.append('<strike>' + productComparePrice + '</strike>');
      }
    } else {
      if ($cardComparePrice.length) {
        $cardComparePrice.text('');
      }
    }


    // update sizes for the selected (linked) product
    var variantsJson = $swatchLi.attr('data-variants-json');
    if (variantsJson) {
      try {
        var variants = JSON.parse(variantsJson);

        /* UPDATE DESKTOP SIZES */
        var $sizesWrapper = $card.find('.js-sizes-wrapper');
        var $form = $card.find('form.js-card-form');
        var $addBtn = $form.find('.collection-page-add-to-cart.submit_btn[type="submit"]');
        var $hiddenVariantInput = $form.find('input[name="id"]');

        // build new size list HTML for desktop
        var sizesHtml = '';
        variants.forEach(function (v) {
          var available = !!v.available;
          var disabledClass = available ? '' : ' size--unavailable';
          var dataAvailable = available ? 'true' : 'false';

          sizesHtml +=
            '<li class="item-size sizes-list-item' + disabledClass + '"' +
            ' data-variant-id="' + v.id + '"' +
            ' data-variant-available="' + dataAvailable + '"' +
            ' data-variant-url="' + (v.url || '') + '"' +
            ' @click="setSelectedVariant(\'' + v.id + '\', \'\')"' +
            '>' +
            v.size +
            '</li>';
        });

        $sizesWrapper.html(sizesHtml);

        // Re-apply grid layout
        var wrapperEl = $sizesWrapper.get(0);
        if (wrapperEl) {
          wrapperEl.classList.remove('collection-sizes-grid-5', 'collection-sizes-grid-4', 'collection-sizes-grid-2');
          collectionSizesSetGrid(wrapperEl);
        }

        // Re-attach click events
        if (wrapperEl) {
          wrapperEl.querySelectorAll('.sizes-list-item').forEach(function (el) {
            collectionSizesSetEvent(el);
          });
        }

        // reset button + hidden variant until a size is clicked
        if ($addBtn.length) {
          $addBtn.prop('disabled', true);
          if ($addBtn.val) {
            $addBtn.val('Please Select Size');
          }
        }
        if ($hiddenVariantInput.length) {
          $hiddenVariantInput.val('');
        }

        // <u></u><u></u><u> UPDATE MOBILE MODAL SIZES </u><u></u><u></u>
        var $modal = $card.find('.add-to-bag-modal');
        var $modalSizeList = $modal.find('.list-variants.main-list-variants.size_list');
        var $modalForm = $modal.find('form');
        var $modalAddBtn = $modalForm.find('.collection_add.submit_btn');
        var $modalNotifyBtn = $modal.find('.notify-me-a');
        var $modalSelect = $modal.find('.product-select');
        var $modalDropdown = $modal.find('.dropdownbox-selected-variant');

        if ($modalSizeList.length) {
          var productId = $modalSizeList.attr('value') || '';

          // Build mobile size list HTML
          var mobileSizesHtml = '';
          variants.forEach(function (v, index) {
            var available = !!v.available;
            var checkedAttr = index === 0 ? 'checked' : '';
            var sizeDisplay = v.size;
            var oosClass = available ? '' : ' variant__ofs';
            var notifyText = available ? '' : '<span class="notify-me-text">Notify Me When Available</span>';

            mobileSizesHtml +=
              '<li class="' + oosClass + '">' +
              '<input ' +
              'data-url="' + (v.url || '') + '&oos=1" ' +
              'data-variant-id="' + v.id + '" ' +
              'data-variant-price="' + (v.price || '') + '" ' +
              'type="radio" ' +
              'id="' + productId + '-size-' + v.id + '" ' +
              'name="size" ' +
              'value="' + sizeDisplay.toLowerCase().replace(/\s+/g, '-') + '" ' +
              checkedAttr +
              '>' +
              '<label class="size_get" for="' + productId + '-size-' + v.id + '">' +
              '<strong></strong>' +
              '<div>' +
              '<span class="inline">' + sizeDisplay + '</span>' +
              '</div>' +
              notifyText +
              '</label>' +
              '</li>';
          });

          $modalSizeList.html(mobileSizesHtml);

          // Update the product-select options in modal
          if ($modalSelect.length) {
            var selectOptionsHtml = '';
            variants.forEach(function (v) {
              var available = !!v.available;
              var disabledAttr = available ? '' : 'disabled="disabled"';
              var dataFields = 'data-size="' + v.size.toLowerCase().replace(/\s+/g, '-') + '" ';
              dataFields += 'data-variant-id="' + v.id + '" ';

              selectOptionsHtml +=
                '<option ' +
                disabledAttr + ' ' +
                'value="' + v.id + '" ' +
                'handle="' + (v.url || '') + '" ' +
                dataFields +
                'data-inventory_quantity="' + (available ? '1' : '0') + '"' +
                '>' +
                v.size + (available ? '' : ' - Sold out') +
                '</option>';
            });

            $modalSelect.html(selectOptionsHtml);
          }

          // Reset modal UI
          if ($modalDropdown.length) {
            $modalDropdown.text('Please Select');
          }

          if ($modalAddBtn.length) {
            $modalAddBtn.prop('disabled', true);
            $modalAddBtn.val('Please Select Size');
            $modalAddBtn.show();
          }

          if ($modalNotifyBtn.length) {
            $modalNotifyBtn.hide();
          }

          // Re-attach change events for mobile size selection
          $modalSizeList.find('input[type="radio"]').off('change').on('change', function () {
            var $input = $(this);
            var variantId = $input.data('variant-id');
            var variantPrice = $input.data('variant-price');
            var variantUrl = $input.data('url');
            var isOOS = $input.closest('li').hasClass('variant__ofs');

            // Update hidden select
            $modalSelect.find('option[value="' + variantId + '"]').prop('selected', true).trigger('change');

            // Update dropdown text
            var sizeText = $input.next('label').find('.inline').text();
            if ($modalDropdown.length) {
              $modalDropdown.text(sizeText + (variantPrice ? ' - ' + variantPrice : ''));
            }

            // Update button state
            if (isOOS) {
              $modalAddBtn.hide();
              $modalNotifyBtn.show();
              $modalNotifyBtn.attr('href', variantUrl);
            } else {
              $modalAddBtn.show();
              $modalAddBtn.prop('disabled', false);
              $modalAddBtn.val('Add To Bag');
              $modalAddBtn.removeClass('notify');
              $modalNotifyBtn.hide();
            }

            // Update hidden form input
            $modalForm.find('input[name="id"]').val(variantId);
          });
        }

      } catch (err) {
        console.error('Failed to parse variants json from swatch', err);
      }
    }

  });

  // Helper function to update modal when it opens
  $(document).on('click', '.add-to-bag-modal-open', function (e) {
    var $this = $(this);
    var $modal = $this.siblings('.add-to-bag-modal');

    // Trigger change on first radio to initialize modal state
    setTimeout(function () {
      $modal.find('.list-variants.size_list input[type="radio"]:checked').trigger('change');
    }, 50);
  });

  $(document).on('keydown', '.product-swatches .swatch-btn', function (e) {
    if (e.key == 'Enter' || e.key == ' ') {
      e.preventDefault();
      $(this).click();
    }
  });
}
initCollectionGridEvents();

function applySizeAvailabilityFilter() {

  const params = new URLSearchParams(window.location.search);
  const selectedSizes = params.getAll('filter.v.option.size').map(size => decodeURIComponent(size).toLowerCase().trim());

  //only running logic when the size filter is being applied
  const sizeFilterApplied = selectedSizes.length > 0;

  document.querySelectorAll('#product-grid .grid__item').forEach(item => {
    //using the size availability attribute to check if a size is in stock. If its not, hiding the cards display

    //ensuring JS filtering of cards doesnt run when no size filters are applied
    if (!sizeFilterApplied) {
      item.style.display = '';
      return;
    }

    const isSearchPage = window.location.pathname.startsWith('/search');

    //hiding products without size when the size filter is applied. Except for on Search page, as Search urls have a  different structure
    const data = item.dataset.sizeAvailability;

    if (!data) {
      item.style.display = isSearchPage ? '' : 'none';
      return;
    }

    const availability = JSON.parse(data);

    //Hiding product card if any of the selected filter sizes are unavailable on the product
    const hasAllSizes = selectedSizes.every(size =>
      Object.prototype.hasOwnProperty.call(availability, size)
    );

    if (!hasAllSizes) {
      item.style.display = 'none';
      return;
    }

    const allInStock = selectedSizes.every(size => availability[size] === true);
    item.style.display = allInStock ? '' : 'none';

  });
}

// Function to run applySizeAvailabiltyFilter() only after the product grid has stabilised
function waitForGridAndApplyFilter() {
  let lastHTML = '';

  function checkGrid() {
    const grid = document.querySelector('#product-grid');
    if (!grid) {
      setTimeout(checkGrid, 200);
      return;
    }

    const currentHTML = grid.innerHTML;

    if (currentHTML !== lastHTML) {
      lastHTML = currentHTML;
      applySizeAvailabilityFilter();
    }

    setTimeout(checkGrid, 200);
  }

  checkGrid();
}

document.addEventListener('DOMContentLoaded', () => {
  applySizeAvailabilityFilter(); // running on first load
  waitForGridAndApplyFilter();   // watching for AJAX updates
});

